import React from "react";
import PageShell from "../../components/layout/PageShell";

export default function Historique() {
  return (
    <PageShell
      title="Historique de l'École"
      subtitle="L'histoire de l'École de la Magistrature : une vision pour une justice moderne en Haïti"
    >
      {/* Introduction */}
      <section className="ema-block">
        <h2 className="ema-h3">Notre histoire</h2>
        <p className="ema-paragraph">
          L'École de la Magistrature (EMA) a été créée pour répondre à un besoin crucial : former des magistrats
          compétents, éthiques et indépendants capables de servir la justice haïtienne avec excellence. Depuis sa
          création, l'EMA s'est engagée à renforcer le système judiciaire national par une formation de qualité.
        </p>
      </section>

      <div className="ema-divider" />

      {/* Chronologie */}
      <section className="ema-block">
        <h2 className="ema-h3">Chronologie des étapes clés</h2>
        <div className="ema-timeline" style={{ marginTop: 14 }}>
          <Timeline year="2015" title="Création de l'EMA" text="L'École de la Magistrature est établie comme institution publique de formation des magistrats." />
          <Timeline year="2016" title="Première promotion" text="Lancement du premier programme de formation initiale pour les juges de paix et les greffiers." />
          <Timeline year="2018" title="Extension des programmes" text="Ouverture de la formation aux juges des tribunaux de première instance et des cours d'appel." />
          <Timeline year="2020" title="Formation continue" text="Mise en place de programmes de formation continue pour les magistrats en fonction." />
          <Timeline year="2022" title="Renforcement institutionnel" text="Développement de partenariats internationaux et modernisation des programmes pédagogiques." />
          <Timeline year="2024" title="Innovation pédagogique" text="Introduction de nouvelles méthodes d'enseignement et de technologies éducatives." />
          <Timeline year="2026" title="Expansion continue" text="Renforcement de la capacité d'accueil et diversification des programmes de formation." />
        </div>
      </section>

      <div className="ema-divider" />

      {/* Évolution */}
      <section className="ema-block">
        <h2 className="ema-h3">Évolution de l'institution</h2>
        <div className="ema-grid-2" style={{ marginTop: 14 }}>
          <div className="ema-panel">
            <h3 className="ema-h3">Débuts modestes</h3>
            <p className="ema-paragraph">
              L'EMA a débuté avec des ressources limitées mais une vision claire : former des magistrats de qualité
              pour améliorer l'accès à la justice en Haïti. Les premières promotions ont montré l'importance et la
              pertinence de cette institution.
            </p>
          </div>
          <div className="ema-panel">
            <h3 className="ema-h3">Croissance progressive</h3>
            <p className="ema-paragraph">
              Au fil des années, l'EMA a étendu ses programmes, développé ses infrastructures et renforcé ses
              partenariats avec des institutions nationales et internationales pour offrir une formation de plus
              en plus complète.
            </p>
          </div>
        </div>
      </section>

      <div className="ema-divider" />

      {/* Perspectives */}
      <section className="ema-block">
        <h2 className="ema-h3">Perspectives d'avenir</h2>
        <p className="ema-paragraph">
          L'EMA continue d'évoluer pour répondre aux besoins changeants du système judiciaire haïtien. Nos perspectives
          incluent :
        </p>
        <ul className="ema-list" style={{ marginTop: 12 }}>
          <li>Expansion des programmes de formation spécialisée</li>
          <li>Développement de partenariats avec d'autres écoles de magistrature</li>
          <li>Intégration des technologies numériques dans l'enseignement</li>
          <li>Renforcement de la recherche juridique appliquée</li>
          <li>Formation continue régulière pour tous les magistrats</li>
        </ul>
      </section>
    </PageShell>
  );
}

function Timeline({ year, title, text }) {
  return (
    <div className="ema-step">
      <div className="ema-step-num ema-step-num-wide">{year}</div>
      <div className="ema-step-body">
        <h3 className="ema-h3" style={{ margin: 0 }}>{title}</h3>
        <p className="ema-paragraph" style={{ marginTop: 10 }}>{text}</p>
      </div>
    </div>
  );
}
